export default __webpack_public_path__ + "6c5deeb5c3e7a41c48ef8774536b86eb.svg";